import { render, staticRenderFns } from "./LevBadge.vue?vue&type=template&id=e97defc2"
import script from "./LevBadge.vue?vue&type=script&lang=js"
export * from "./LevBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports